import moment from "moment-jalaali";
import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

export const convertDate = (date) => {
  if (!date) return null;
  const parts = date.split('-');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return date;
};
export const getDate = (e) => {
  const date = new DateObject({date: e, calendar: gregorian, locale: gregorian_en})
  const SelectedDate = (new Date(date.toDate()).toISOString())
  return SelectedDate;
}

export const convertToJalali = (gregorianDate) => {

  let formattedDate = moment(gregorianDate).format(
    'jYYYY/jMM/jDD'
  );

  return formattedDate;
};

export function jalaliToISOFixed(jalaliDate) {
  if (!jalaliDate || jalaliDate === "") return "";

  try {
    const gregorian = moment(jalaliDate, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
    return `${gregorian}T00:00:00+03:30`;
  } catch (error) {
    console.error("Error converting date:", error);
    return "";
  }
}